import { defineComponent as _defineComponent } from 'vue'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingDocsIADialogComponent',
  setup(__props) {

const { t } = useI18n()

return { __sfc: true,t, SpinnerLayerComponent }
}

})